import actions from './actions'

export default function Invoice2ItemsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        // editing: null,
        saveSuccess: false,
      }

    case actions.LIST_WORKORDER_FOR_EXISTING_INVOICE2_ITEM:
      return {
        ...state,
        editing: { workOrderID: 0 },
        result: action.result,
        deletedWorkOrderFromInvoice2Item: false,
        loading: false,
      }

    case actions.DELETE_WORKORDERS_FROM_INVOICE2_ITEM_RECIEVED:
      console.log('Workorder DELETE_WORKORDERS_FROM_INVOICE2_ITEM_RECIEVED')
      return {
        ...state,
        editing: { workOrderID: 0 },
        deletedWorkOrderFromInvoice2Item: true,
        loading: false,
      }
    case actions.ADD_WORKORDERS_TO_INVOICE2_ITEM_RECIEVED:
      console.log('ADD_WORKORDERS_TO_INVOICE2_ITEM_RECIEVED', action.result, state)
      return {
        ...state,
        addWorkOrdersToInvoice2ItemResult: action.result,
        loading: false,
      }
    default:
      return state
  }
}
